import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function ExportChannels({ outboundDistributions = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "region", label: "Region" },
        { key: "volume_pct", label: "Volume (%)" },
        { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
        // { key: "export_risk", label: "Export Risk" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "region", label: "Region" },
        { key: "volume_pct", label: "Volume (%)" },
        { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
        { key: "export_risk", label: "Export Risk" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const dataArray = Array.isArray(outboundDistributions)
      ? outboundDistributions
      : [outboundDistributions];

    // Clean up nested fields if any (example: remove outbound_modes)
    const cleanedData = dataArray.map((item) => {
      const { outbound_modes, ...restResponse } = item.response || {};
      return { ...item, response: restResponse };
    });

    const transformed = transformResultsToCompProfileData(cleanedData);
    setTabData(transformed);

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={outboundDistributions?.[0]?.response?.tableComments || ""}
      />
    );
  }, [outboundDistributions]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Export Channels"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="region"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default ExportChannels;
